import { useContext } from "react";
import { AppContext } from "../../scripts/context";
import NFTCollections from "./NFTCollections";
import NFTSlider from "./NFTSlider";
import SelectedNFT from "./SelectedNFT";

export default function CardBody() {
  const { state, nftItems } = useContext(AppContext);

  if (state.contracts.nft.data.seletedNFT) {
    return <SelectedNFT />;
  } else if (nftItems.length > 0) {
    return <NFTSlider />;
  } else {
    return <NFTCollections />;
  }
}
